<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="54" viewBox="0 0 147 53" class="centre">
    <defs>
        <filter id="f4" x="-1" y="0" width="250%" height="200%">
            <feOffset result="offOut" in="SourceAlpha" dx="2" dy="2" />
            <feGaussianBlur result="blurOut" in="offOut" stdDeviation="2" />
            <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
        </filter>
    </defs>

    <g font-family="sans-serif" font-size="36px" font-weight="bold"
        stroke-width="11px" stroke-linejoin="round" text-anchor="middle" filter="url(#f4)">
        <text x="72" y="34" fill="none" stroke="white">{{text}}</text>
        <text x="72" y="34" fill="blue" stroke="none">{{text}}</text>
    </g>
</svg>
